import { Model } from 'pinia-orm';

export default class Feature extends Model {

    static get entity () {
        return 'features';
    }

    static fields () {
        return {
            id: this.uid(),
            title: this.attr({}),
            description: this.attr({}),
            key: this.attr(null),
            early_access: this.attr(false),
            start_date: this.attr(null),
            end_date: this.attr(null),
        }
    }
}
